var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.form_data
    ? _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-group col-md-6" }, [
              _c("label", { attrs: { for: "ex_rate_offset" } }, [
                _vm._v("Exchange Rate Offset")
              ]),
              _vm._v(" "),
              _c("small", [
                _vm._v(
                  "Used in the calculation of landed cost. Actual landed may be different."
                )
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.form_data.exchange_rate_offset,
                    expression: "form_data.exchange_rate_offset",
                    modifiers: { number: true }
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  name: "ex_rate_offset",
                  id: "ex_rate_offset",
                  placeholder: ""
                },
                domProps: { value: _vm.form_data.exchange_rate_offset },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.form_data,
                      "exchange_rate_offset",
                      _vm._n($event.target.value)
                    )
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              _vm._v(" "),
              _c("div", [
                _c("i", [
                  _vm._v("Current exchange rate: "),
                  _c("strong", [_vm._v(_vm._s(_vm.exRate))]),
                  _vm._v(". Rate with offset: "),
                  _c("strong", [_vm._v(_vm._s(_vm.effectiveExRate))])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "btn btn-default", attrs: { type: "submit" } },
            [_vm._v("Save")]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dbc44864", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbc44864","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Forms/Settings.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-dbc44864","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Forms/Settings.vue
// module chunks = 0